export default __webpack_public_path__ + "static/media/chart1.e5fac1b9.png";